import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ORG_PERSON_MODAL';

export const {action: showOrganizationPersonModal} = createAction(`${domain}/SHOW`, organizationId => ({
    organizationId,
}));

export const {action: showEditPerson} = createAction(`${domain}/EDIT`, person => ({person}));

export const {action: hideOrganizationPersonModal} = createAction(`${domain}/HIDE`, () => ({}));
